import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { BreadcrumbsProps } from "./breadcrumb-component-new.types";
import "./breadcrumb-component-new.scss"; // <-- import SCSS

function CustomBreadcrumbs({ items }: BreadcrumbsProps) {
  const navigate = useNavigate();

  const handleClick = (to?: string, state?: any) => {
    if (to) navigate(to, { state });
  };

  return (
    <Breadcrumbs aria-label="breadcrumb" className="breadcrumbs-container">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = !!item.to || !!item.onClick;

        if (!isClickable || isLast) {
          return (
            <Typography
              key={index}
              className="breadcrumb-item breadcrumb-item--last"
            >
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={index}
            className="breadcrumb-item breadcrumb-item--link"
            onClick={() => {
              if (item.onClick) {
                item.onClick();
              } else if (item.to) {
                handleClick(item.to, item.state);
              }
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default CustomBreadcrumbs;
